import React, { useState, useEffect } from "react";
import { useLanguage } from '../context/LanguageContext';
import API_BASE_URL from '../services/apiconfig';

const Ecs = () => {
  const { language } = useLanguage();
  const [loading, setLoading] = useState(true);
  const [ecsData, setEcsData] = useState(null);

  useEffect(() => {
    fetchEcsData();
  }, []);

  const fetchEcsData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/ecs/get_ecs_content`);
      const result = await response.json();

      if (result.status === 'success' && result.data) {
        setEcsData(result.data);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching ECS data:', error);
      setLoading(false);
    }
  };

  const content = {
    en: {
      title: "Employees Cooperative Thrift and Credit Societies",
      overview: "Overview",
      keyStats: "Key Stats",
      servicesOffered: "Services Offered",
      policy: "Policy and Governance"
    },
    ta: {
      title: "பணியாளர் சிக்கன மற்றும் கூட்டுறவுக் கடன் சங்கங்கள்",
      overview: "கண்ணோட்டம்",
      keyStats: "முக்கிய புள்ளிவிவரங்கள்",
      servicesOffered: "வழங்கப்படும் சேவைகள்",
      policy: "கொள்கை மற்றும் நிர்வாகம்"
    }
  };

  const t = content[language];

  const pickLang = (item, engKey, taKey) =>
    language === 'en' ? (item?.[engKey] || '') : (item?.[taKey] || item?.[engKey] || '');

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-xl text-gray-600">Loading...</div>
      </div>
    );
  }

  if (!ecsData) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-xl text-gray-600">No ECS data available</div>
      </div>
    );
  }

  const overview = language === 'en' ? ecsData.overview_eng : (ecsData.overview_tamil || ecsData.overview_eng);
  const services = ecsData.services_offered || {};
  const points = services.points_json_data || [];

  return (
    <div className="min-h-screen bg-gray-50">

      {/* Header */}
      <div className="bg-blue-50 border-b border-blue-100">
        <div className="mx-auto px-4 py-10">
          <h1 className="text-3xl font-bold text-gray-800 text-center">
            {t.title}
          </h1>
        </div>
      </div>

      {/* Main Content */}
      <div className="mx-auto px-4 py-8">

        <section id="ecs-section" className="bg-white p-8 rounded-lg shadow-sm">

          {/* OVERVIEW */}
          {overview && (
            <div id="ecs-overview" className="mb-10">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">{t.overview}</h3>
              <div className="bg-blue-50 p-6 rounded-lg">
                <p className="text-gray-700 leading-relaxed">{overview}</p>
              </div>
            </div>
          )}

          {/* SERVICES OFFERED */}
          {(services.header_eng || points.length > 0) && (
            <div id="ecs-services" className="mb-10">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">{t.servicesOffered}</h3>
              <div className="bg-purple-50 p-6 rounded-lg">
                <p className="text-gray-700 mb-4">
                  {pickLang(services, 'header_eng', 'header_tamil')}
                </p>

                {points.length > 0 && (
                  <div className="bg-white p-5 rounded-lg">
                    <ul className="space-y-4">
                      {points.map((service, index) => (
                        <li key={index} className="flex items-start">
                          <span className="text-purple-600 mr-3 font-bold text-lg">•</span>
                          <div>
                            <span className="text-gray-800 font-semibold">
                              {pickLang(service, 'head_eng', 'head_tamil')}
                            </span>
                            <p className="text-gray-600 text-sm mt-1">
                              {pickLang(service, 'content_eng', 'content_tamil')}
                            </p>
                          </div>
                        </li>
                      ))}
                    </ul>

                    {(services.footer_eng || services.footer_tamil) && (
                      <div className="mt-5 pt-4 border-t border-gray-200">
                        <p className="text-gray-600 text-sm italic">
                          {pickLang(services, 'footer_eng', 'footer_tamil')}
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}

        </section>

      </div>
    </div>
  );
};

export default Ecs;
